import React from 'react';
import { Input, Button, createUseStyles } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';
import classnames from 'classnames';

import styles from './styles';

const useStyles = createUseStyles(styles, 'Text');

function Text({
    className,
    placeholder,
    onButtonClick,
    buttonLabel = 'cfm_action_add',
    buttonClassName,
    ...props
}) {
    const { t } = useWeb5Context();
    const onClick = () => {
        onButtonClick && onButtonClick();
    };

    const classes = useStyles();
    const rootClasses = classnames(classes.root, className);
    const buttonClasses = classnames(classes.button, buttonClassName);

    return (
        <div className={rootClasses}>
            <Input
                labelMode="horizontal"
                placeholder={placeholder || t('cfm_placeholder_type_value')}
                {...props}
            />
            {onButtonClick && (
                <div className={buttonClasses}>
                    <Button size="small" type="secondary" onClick={onClick}>
                        {t(buttonLabel)}
                    </Button>
                </div>
            )}
        </div>
    );
}

export default Text;
